export const DEBUG = import.meta.env.VITE_DEBUG_MODE === 'true';
